import { styled, YStack } from 'tamagui'
import { ActivityIndicator } from 'react-native'
import type { ComponentProps } from 'react'

const SpinnerWrap = styled(YStack, {
  name: 'Spinner',
  ai: 'center',
  jc: 'center',
})

type Size = 'small' | 'large'

interface SpinnerProps extends ComponentProps<typeof SpinnerWrap> {
  size?: Size
  color?: string
}

const SIZE_MAP: Record<Size, number> = { small: 20, large: 36 }

export function Spinner({ size = 'small', color, ...rest }: SpinnerProps) {
  return (
    <SpinnerWrap {...rest}>
      <ActivityIndicator size={SIZE_MAP[size]} color={color ?? undefined} />
    </SpinnerWrap>
  )
}
